// External Imports
import { Fragment, useContext, useState } from "react";
import { TbChevronDown, TbChevronUp } from "react-icons/tb";

// Internal Imports
import { isoDateToString } from "../../util/format-date";
import { UtilityContext } from "../../context/util-context";
import ListLabels from "../UI/ListLabels";
import Heading from "../UI/Heading";
import NoRecordsFound from "../UI/NoRecordsFound";

/** ========================================================================
 * * BookingPayments Component
 * This component renders a list of payments by a customer.
 * ========================================================================== */

const statuses = ["pending", "delinquent", "succeeded", "refunded"];

export default function BookingPayments({ payments = [] }) {
  // Load Context
  const { navigate } = useContext(UtilityContext);

  // Initialize States
  const [show, setShow] = useState(false);

  // Sort payments by date
  payments = payments.sort(
    (a, b) => new Date(b.dateCreated) - new Date(a.dateCreated)
  );

  return (
    <div className="grid gap-2">
      <Heading
        title="Payments"
        text="List of all payments related to this booking."
        onClick={() => setShow(!show)}
        isBackArrow={false}
      >
        {show ? (
          <TbChevronUp className="icon" onClick={() => setShow(false)} />
        ) : (
          <TbChevronDown className="icon" onClick={() => setShow(true)} />
        )}
      </Heading>

      {show &&
        (payments.length > 0 ? (
          <Fragment>
            <div className="labels lg:grid-cols-8">
              <ListLabels
                labels={[
                  "Date Created",
                  { classes: "lg:col-span-3", name: "Description" },
                  "Due Date",
                  "Date Paid",
                  "Paid Via",
                  "Amount",
                ]}
              />
            </div>
            <div className="list max-h-[300px]">
              {payments.map((payment) => (
                <div
                  key={payment.id}
                  className={
                    [
                      "border-yellow-500",
                      "border-red-500",
                      "border-green-500",
                      "border-sky-500",
                    ][statuses.indexOf(payment.status)] +
                    " pill grid lg:grid-cols-8 text-sm text-stone-200"
                  }
                  onClick={(e) =>
                    navigate(`/payments/info?id=${payment.id}`, e)
                  }
                >
                  <p className="text-stone-400">
                    {isoDateToString(payment.dateCreated)}
                  </p>
                  <p className="font-semibold lg:col-span-3">
                    {payment.description}
                  </p>
                  <p className="text-stone-400">
                    {isoDateToString(payment.dueDate) || "-"}
                  </p>
                  <p className="text-stone-400">
                    {isoDateToString(payment.datePaid) || "-"}
                  </p>
                  <p className="text-stone-400">
                    {payment.paidVia}
                  </p>
                  <p className="font-semibold">${payment.amount?.toFixed(2)}</p>
                </div>
              ))}
            </div>
          </Fragment>
        ) : (
          <NoRecordsFound />
        ))}
    </div>
  );
}
